(() => {
  const normalize = (value) => value.toLocaleLowerCase().trim();

  document.querySelectorAll('[data-store-directory]').forEach((directory) => {
    const input = directory.querySelector('[data-store-search]');
    const cards = Array.from(directory.querySelectorAll('[data-store-card]'));
    const empty = directory.querySelector('[data-store-search-empty]');
    const count = directory.querySelector('[data-store-visible-count]');

    if (!input || cards.length === 0) return;

    const filterCards = () => {
      const query = normalize(input.value);
      let visible = 0;

      cards.forEach((card) => {
        const matches = !query || normalize(card.dataset.search || '').includes(query);
        card.hidden = !matches;
        if (matches) visible += 1;
      });

      if (empty) empty.hidden = visible !== 0;
      if (count) count.textContent = String(visible);
    };

    input.addEventListener('input', filterCards);
  });

  document.querySelectorAll('[data-copy-discount]').forEach((button) => {
    button.addEventListener('click', async () => {
      const code = button.dataset.code || '';
      if (!code) return;

      try {
        await navigator.clipboard.writeText(code);
      } catch (_error) {
        const textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        textarea.remove();
      }

      const originalLabel = button.querySelector('[data-copy-label]');
      if (!originalLabel) return;
      originalLabel.textContent = 'Copied';
      window.setTimeout(() => {
        originalLabel.textContent = 'Copy code';
      }, 1800);
    });
  });

  document.querySelectorAll('[data-store-detail]').forEach((detail) => {
    const dialog = detail.querySelector('[data-store-gallery-dialog]');
    const preview = detail.querySelector('[data-store-gallery-preview]');
    const closeButton = detail.querySelector('[data-store-gallery-close]');
    const triggers = Array.from(detail.querySelectorAll('[data-store-gallery-open]'));
    let activeTrigger = null;

    if (!dialog || !preview || !closeButton || triggers.length === 0) return;

    const closeDialog = () => {
      if (dialog.open) dialog.close();
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const src = trigger.dataset.gallerySrc || '';
        if (!src) return;

        activeTrigger = trigger;
        preview.src = src;
        preview.alt = trigger.dataset.galleryAlt || '';
        dialog.showModal();
      });
    });

    closeButton.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', () => {
      preview.removeAttribute('src');
      preview.alt = '';
      activeTrigger?.focus();
      activeTrigger = null;
    });
  });
})();
